module.exports = __webpack_public_path__ + "img/close-modal.7be246d4.svg";